import { sendBeacon } from "./beacon/user-timing";
import { onCLS, onFCP, onINP, onLCP } from "web-vitals/attribution";

import { performanceBeaconTracker } from "./web-vitals/metrics";
import { trackConnectionType } from "./tracking/connection";
import { initFlushQueue } from "./web-vitals/flush-queue";
import { initRumCollection } from "./beacon/rum";
import { addApmLabels, addLcpApmLabels } from "./web-vitals/apm";

window.o_scale ||= {} as never;
window.o_scale.userTiming = { sendBeacon };

/*                            */
onLCP(performanceBeaconTracker);
onFCP(performanceBeaconTracker);
onCLS(performanceBeaconTracker);
onINP(performanceBeaconTracker);

/*                             */
onINP(addApmLabels, { reportAllChanges: true });
onCLS(addApmLabels, { reportAllChanges: true });
/*                                  */
onLCP(addLcpApmLabels, { reportAllChanges: true });

/*                                                         */
initFlushQueue();

/*                                    */
initRumCollection();

/*                                         */
trackConnectionType();
